export default "__VITE_ASSET__e608061f__"